import { matchPerson } from '@weavix/domain/src/people/match-person';
import { model, Model, idProp, prop, createStore, Context, ExtendedModel, computed } from '@weavix/mobx';
import { PersonMatcher } from '@weavix/models/src/person/person-matcher';
import { WorkFormQuestion, WorkFormVersion } from '@weavix/models/src/work-forms/work-forms';
import { facilitiesContext } from 'models-mobx/facilities-store/facilities-store';
import { myUserId } from 'models-mobx/my-profile-store/my-profile-store';
import { peopleContext } from 'models-mobx/people-store/people-store';

@model('WorkForm')
export class WorkForm extends Model({
    id: idProp,
    accountId: prop<string>(),
    name: prop<string>(),
    acceptingResponses: prop<boolean>(),
    facilityIds: prop<string[]>(),
    questions: prop<WorkFormQuestion[]>(),
    facilityId: prop<string>(),
    folderId: prop<string>(),
    tags: prop<string[]>(),
    currentVersion: prop<number>(),
    responseCount: prop<number>(),
    versions: prop<WorkFormVersion[]>(),
    whoCanSubmit: prop<PersonMatcher>(),
}) {
    @computed
    get userCanSubmit(): boolean {
        const onFacility = (facilityId: string) => {
            return facilityIds.includes(facilityId);
        };

        const facilityIds = facilitiesContext.getDefault().getFacilities(myUserId()).map(f => f.id);

        const currentPerson = peopleContext.get().getPerson(myUserId(), this.accountId);
        return this.acceptingResponses !== false && ((!this.whoCanSubmit && (!this.facilityIds?.length || facilityIds.some(x => this.facilityIds.includes(x)))) ||
            matchPerson({ facilityIds: this.facilityIds, ...this.whoCanSubmit }, currentPerson, onFacility));
    }
}

const base = createStore<WorkForm>('work-forms', WorkForm);

export const workFormsContext = base.context as Context<WorkFormsStore>;
export const workFormRef = base.ref;

@model('WorkFormsStore')
export class WorkFormsStore extends ExtendedModel(base.Store, {
}) {
}
